import {Routes} from "@angular/router";
import {HairstylesComponent} from "./hairstyles.component";
import {HairstyleDetailsComponent} from "./pages/hairstyle-details/hairstyle-details.component";

export const HairstylesRoutes: Routes = [
  {
    path: '',
    component: HairstylesComponent
  },
  {
    path: ':name',
    component: HairstyleDetailsComponent
  }
];
